module.exports = __webpack_public_path__ + "media/images/common/title_bg-802fec8e94fc59197fa9f22b9cc7b702.gif";